export default __webpack_public_path__ + "static/media/chinonso.33a5cb88.png";